import { Component, Input } from '@angular/core';
import { Customer } from 'src/app/interfaces/customer';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgIf } from '@angular/common';
import { TranslateTextDirective } from '../../../../directives/translate-text.directive';
import { CardComponent } from '../../../../components/cards/card/card.component';

@Component({
  selector: 'app-organisation-about-us',
  templateUrl: './organisation-about-us.component.html',
  standalone: true,
  imports: [
    CardComponent,
    TranslateTextDirective,
    NgIf,
    InlineSVGModule,
    TranslateModule,
  ],
})
export class OrganisationAboutUsComponent {
  @Input() customer: Customer;
  @Input() language: string;

  constructor() {}
}
